import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategoryNav() {
  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
            漫画分类
          </h2>
          <Link
            to="/category/all"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line ml-1 text-xs"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3">
          {categories.slice(0, 10).map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              className="group flex items-center gap-3 bg-background-50 rounded-xl p-4 hover:bg-background-200/50 transition-all duration-200 cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-200">
                <i className={`${cat.icon} text-lg`}></i>
              </div>
              <div>
                <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">
                  {cat.name}
                </span>
                <p className="text-xs text-foreground-500">{cat.count} 部</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}